import Model from '../../ModelBinding/Model';
import TechnicalDetailCollection from './TechnicalDetailCollection';
import TechnicalDetailValueCollection from '../TechnicalDetailValue/TechnicalDetailValueCollection';

export default class TechnicalDetail extends Model {
  public name?: string;
  public front_rendering?: string;
  public group?: string;
  public order?: number;
  public values?: TechnicalDetailValueCollection;

  bind() {
    this.name = this.getStringAttribute('name');
    this.front_rendering = this.getStringAttribute('front_rendering');
    this.group = this.getStringAttribute('group');
    this.order = this.getIntAttribute('order');
    this.values = this.getRelationCollection(
      'values',
      TechnicalDetailValueCollection,
    ) as TechnicalDetailValueCollection;
  }

  static getCollection() {
    return TechnicalDetailCollection;
  }
}
